
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdatePasswordDtoFormGroup() {
return new FormGroup({
    oldPassword: new FormControl<string | undefined>('', [Validators.required]),
    newPassword: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      